"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stockpileColumnFullWidthProps = exports.stockpileColumnProps = exports.stockpileTypes = void 0;
const constants_1 = require("utils/constants");
exports.stockpileTypes = {
    SET_DATA_GRID: 'STOCKPILE TYPES GET DATA GRID',
    ON_PAGE_CHANGE: 'STOCKPILE TYPES ON PAGE CHANGE',
    ON_MUTATION_CLICK: 'STOCKPILE TYPES ON MUTATION',
    ON_CHANGE_DATAITEM: 'STOCKPILE TYPES ON CHANGE DATAITEM',
    ON_SAVE_DATAITEM: 'STOCKPILE TYPES ON SAVE DATAITEM',
    ON_DELETE: 'STOCKPILE TYPES ON DELETE',
    ON_FILTER_CHANGE: 'STOCKPILE TYPES ON FILTER CHANGE',
    ON_SORT_CHANGE: 'STOCKPILE TYPES ON SORT CHANGE',
    SET_ERROR: 'STOCKPILE TYPES SET ERROR',
    SET_LOADING: 'STOCKPILE TYPES SET LOADING'
};
exports.stockpileColumnProps = [
    {
        show: true,
        field: 'stockpile',
        title: 'Stockpile',
        width: '200px',
        filter: 'text'
    },
    {
        show: true,
        field: 'target_queue_time_display',
        title: 'Target Queue Time',
        width: '200px',
        filter: 'text'
    },
    {
        show: true,
        field: 'target_lead_time_display',
        title: 'Target Lead Time',
        width: '200px',
        filter: 'text'
    },
    {
        show: true,
        field: 'modified_date',
        title: 'Modified Date',
        width: '220px',
        filter: 'date',
        format: `${constants_1.formatGridDate.ddMMYYYY} ${constants_1.formatGridDate.hhMM}`
    },
    {
        show: true,
        field: 'modified_by',
        title: 'Modified By',
        width: '180px',
        filter: 'text'
    },
    {
        show: true,
        field: 'is_active',
        title: 'Status',
        width: '140px',
        filter: 'boolean'
    },
];
exports.stockpileColumnFullWidthProps = [
    ...exports.stockpileColumnProps
];
exports.stockpileColumnFullWidthProps[0] = {
    show: true,
    field: 'stockpile',
    title: 'Stockpile',
    width: 'auto',
    filter: 'text'
};
